import type { Event } from '../lib/types';
import GuidedRsvpModal, {
  type GuidedRsvpData,
  type RsvpStatus,
} from './rsvp/GuidedRsvpModal';

interface PublicRsvpModalProps {
  isOpen: boolean;
  onClose: () => void;
  event: Event;
  onRsvpComplete: (status: RsvpStatus) => void;
}

interface PublicRsvpSubmitResult {
  redirectUrl?: string;
}

export default function PublicRsvpModal({
  isOpen,
  onClose,
  event,
  onRsvpComplete,
}: PublicRsvpModalProps) {
  const handleSubmit = async (data: GuidedRsvpData): Promise<PublicRsvpSubmitResult> => {
    const {
      status,
      firstName,
      lastName,
      phone,
      message,
      adultCount,
      childCount,
      publicGuestView,
      guestQuestionAnswers,
    } = data;

    const requestData = {
      firstName,
      lastName,
      phone,
      status,
      adultCount: status === 'attending' || status === 'maybe' ? adultCount : 1,
      childCount: status === 'attending' || status === 'maybe' ? childCount : 0,
      message,
      publicGuestView: status === 'attending' ? publicGuestView : false,
      eventId: event.id,
      guestQuestionAnswers: status === 'attending' ? guestQuestionAnswers : {},
    };

    const response = await fetch('/api/public/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(errorData?.message || 'Failed to register');
    }

    return response.json();
  };

  return (
    <GuidedRsvpModal
      isOpen={isOpen}
      onClose={onClose}
      event={event}
      requireContactForAllStatuses
      errorContext={{ flow: 'public' }}
      onSubmit={handleSubmit}
      onComplete={(data, result) => {
        const { redirectUrl } = result as PublicRsvpSubmitResult;
        onRsvpComplete(data.status);
        onClose();

        if (redirectUrl) {
          setTimeout(() => {
            window.location.href = redirectUrl;
          }, 100);
        }
      }}
    />
  );
}
